import "../../index34.css";
import { jsxs as u, jsx as e } from "react/jsx-runtime";
import { _ as s } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import C from "../Container/index.js";
import w from "../InfoPopup/index.js";
const g = "_input-section_1cptl_1", S = "_header_1cptl_7", f = "_heading-container_1cptl_8", N = "_heading_1cptl_8", T = "_with-compact-title-section_1cptl_19", P = "_with-padding_1cptl_23", k = "_asterisk_1cptl_27", v = "_description_1cptl_31", x = "_content-section_1cptl_37", j = "_one-column_1cptl_42", y = "_two-column_1cptl_46", I = "_three-column_1cptl_54", z = "_four-column_1cptl_58", A = "_without-title-section_1cptl_63", t = {
  inputSection: g,
  header: S,
  headingContainer: f,
  heading: N,
  withCompactTitleSection: T,
  withPadding: P,
  asterisk: k,
  description: v,
  contentSection: x,
  oneColumn: j,
  twoColumn: y,
  threeColumn: I,
  fourColumn: z,
  withoutTitleSection: A
};
function E(a) {
  const {
    className: l,
    title: r,
    children: d,
    description: h,
    tooltip: i,
    contentSectionClassName: p,
    withoutTitleSection: o = !1,
    withCompactTitleSection: c,
    withoutPadding: _ = !1,
    withAsteriskOnTitle: m,
    numPreferredColumns: n = 1
  } = a;
  return /* @__PURE__ */ u(
    "div",
    {
      className: s(
        t.inputSection,
        o && t.withoutTitleSection,
        !_ && t.withPadding,
        c && t.withCompactTitleSection,
        l
      ),
      children: [
        !o && /* @__PURE__ */ e(
          C,
          {
            heading: r,
            headingDescription: m && /* @__PURE__ */ e("span", { "aria-hidden": !0, className: t.asterisk, children: "*" }),
            headerClassName: t.header,
            headingClassName: t.heading,
            headingContainerClassName: t.headingContainer,
            actions: i && /* @__PURE__ */ e(w, { description: i }),
            childrenContainerClassName: t.description,
            headingLevel: c ? 5 : 4,
            spacing: "cozy",
            children: h
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: s(
              t.contentSection,
              n === 1 && t.oneColumn,
              n === 2 && t.twoColumn,
              n === 3 && t.threeColumn,
              n === 4 && t.fourColumn,
              p
            ),
            children: d
          }
        )
      ]
    }
  );
}
export {
  E as default
};
